define('datakit/hal/hal.model',['require','exports','module','underscore','backbone.radio','../model','./hal.collection','./embedded.model','./links.model','../util/getobject'],function(require, exports, module) {
  var _             = require('underscore');
  var Radio         = require('backbone.radio');
  var Model         = require('../model');
  var HalCollection = require('./hal.collection');
  var EmbeddedModel = require('./embedded.model');
  var LinksModel    = require('./links.model');
  var getobject     = require('../util/getobject');

  var HalModel = Model.extend({

    channelReplyName: 'DataKit.HalModel',

    useHalSelfLinkAsUrl: true,

    clear: function() {
      this._links.clear();
      return Model.prototype.clear.apply(this, arguments);
    },

    onBeforeFirstSet: function(attrs, options) {
      Model.prototype.onBeforeFirstSet.apply(this, arguments);

      this._embedded = new EmbeddedModel({}, { childModels: this.childModels });
      this._links    = new LinksModel({});

      this.registerGetter(function(attr) {
        var firstPart = getobject.getParts(attr)[0];
        return this.hasEmbedded(firstPart);
      }, function(attr) {
        var parts = getobject.getParts(attr);
        attr = parts.slice(1).join('.');
        return this.getEmbedded(parts[0]).get(attr);
      });

      this.registerSetter('_links', function(attr, value) {
        this.setLinks(value);
      });
      this.registerSetter('_embedded', function(attr, value) {
        this.setEmbedded(value);
      });

      this.registerCloner(function(model, options) {
        model._embedded = this.getEmbedded().clone();
        model._links    = this.getLinks().clone();
      });

      this.registerSerializer(this._serializeHalAttributes);
    },

    url: function() {
      var links = this.getLinks();
      if (this.useHalSelfLinkAsUrl && links.has('self.href')) {
        return links.get('self.href');
      }
      return Model.prototype.url.apply(this, arguments);
    },

    hasEmbedded: function(rel) {
      return this._embedded.has(rel);
    },

    hasLink: function(rel) {
      return this._links.has(rel);
    },

    getEmbedded: function(rel, options) {
      options = options || {};
      var ret = this._embedded;
      if (_.isString(rel)) {
        ret = ret.get(rel);

        if (!ret && options.create) {
          this.setEmbedded(rel, {});
          return this.getEmbedded(rel, {});
        }
      }
      return ret;
    },

    getLink: function(rel) {
      return this.getLinks().get(rel);
    },

    getLinks: function() {
      return this._links;
    },

    setEmbedded: function(rel, halResource) {
      this.getEmbedded().set(rel, halResource);
      return this;
    },

    setLinks: function(rel, halResource) {
      this.getLinks().set(rel, halResource);
      return this;
    },

    unsetEmbedded: function(rel, options) {
      this.getEmbedded().unset(rel, options);
    },

    unsetLink: function(rel, options) {
      this.getLinks().unset(rel, options);
    },

    _serializeHalAttributes: function(json, options) {
      var contentType = options.contentType || HalModel.contentType || 'application/json',
          embedded    = this.getEmbedded().toJSON(options),
          links       = this.getLinks().toJSON(options);

      if (contentType === 'application/json') {
        return embedded;
      } else if (contentType === 'application/hal+json') {
        var ret = {};
        if (!_.isEmpty(links)) {
          ret._links = links;
        }
        if (!_.isEmpty(embedded)) {
          ret._embedded = embedded;
        }
        return ret;
      }
    }

  },
  {

    Collection: HalCollection

  });

  Radio.channel('models').reply('DataKit.HalModel', _.constant(HalModel));

  module.exports = HalModel;
});

